import script from "./AccessDcMobileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessDcMobileCard.vue?vue&type=script&setup=true&lang=js"

import "./AccessDcMobileCard.vue?vue&type=style&index=0&id=0d900cf4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d900cf4"]])

export default __exports__